import React from "react";

function SpeakerIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      fill="none"
      viewBox="0 0 20 21"
    >
      <path
        fill="#fff"
        d="M11 5.5a1.5 1.5 0 00-3 0v9a1.5 1.5 0 003 0v-9zM6 2.5a1.5 1.5 0 10-3 0v15a1.5 1.5 0 003 0v-15zM16 2.5a1.5 1.5 0 00-3 0v15a1.5 1.5 0 003 0v-15z"
      ></path>
    </svg>
  );
}

export default SpeakerIcon;
